import React, { useRef } from 'react';
import { useFocusTrap } from '@anton.bobrov/react-hooks';
import cx from 'classnames';
import '../../../Context/index.js';
import { BackButton } from './BackButton/index.js';
import { AsideMenu } from '../AsideMenu/index.js';
import styles from './index.module.scss.js';
import { useLayoutContext } from '../../../Context/utils/useLayoutContext.js';

const AsideMenuMobile = ({
  className,
  style,
  onSearch,
  onLogoClick,
  socials,
  tabs,
  navBack = true
}) => {
  const ref = useRef(null);
  const { isModalMenuOpen, setIsModalMenuOpen, setIsAsideMenuOpen } = useLayoutContext();
  useFocusTrap(ref, { isDisabled: !isModalMenuOpen });
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ref,
      className: cx(styles.box, className, {
        [styles.open]: isModalMenuOpen
      }),
      style,
      role: "dialog",
      "aria-modal": true,
      "data-mobile-nav-menu": true
    },
    /* @__PURE__ */ React.createElement(
      "button",
      {
        className: styles.shadow,
        type: "button",
        "aria-label": "close menu",
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsModalMenuOpen(false);
          setIsAsideMenuOpen(false);
        }
      }
    ),
    navBack && /* @__PURE__ */ React.createElement("div", { className: styles.section }, /* @__PURE__ */ React.createElement(
      BackButton,
      {
        onClick: () => {
          setIsModalMenuOpen(false);
          setIsAsideMenuOpen(false);
        }
      }
    )),
    /* @__PURE__ */ React.createElement("div", { className: styles.body }, /* @__PURE__ */ React.createElement(
      AsideMenu,
      {
        className: styles.aside,
        onLogoClick,
        socials,
        tabs,
        onSearch,
        tabsVersion: "v3"
      }
    ))
  );
};
AsideMenuMobile.displayName = "Layout.AsideMenuMobile";

export { AsideMenuMobile };
//# sourceMappingURL=index.js.map
